import { __generator } from "tslib";
import { takeLatest } from 'redux-saga/effects';
import * as actionTypes from '../constants/actionTypes';
export default function setEmbedlyContainerHeight() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeLatest(actionTypes.SET_CONTAINER_HEIGHT, function (_a) {
                    var height = _a.height;
                    // See http://docs.embed.ly/v1.0/docs/provider-height-resizing
                    window.parent.postMessage(JSON.stringify({
                        src: window.location.toString(),
                        context: 'iframe.resize',
                        height: height,
                    }), '*');
                })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
